import React from 'react';
import { SatQuestionArea, SatToolTip } from '@components/common/satUI';

/**
 * 문항 영역
 */
const QuestionArea = props => {
  const {
    isPreUw = false,
    group,
    tbNbsPolicyBfNtceAnsDtlDTO,
    setTbNbsPolicyBfNtceAnsDtlDTO,
    tbNbsPolicyBfNtceAnsByitmDtlDTO,
    noticeDutyTooltips,
    setNoticeDutyTooltips,
    onSave,
  } = props;

  return (
    <SatQuestionArea
      locked={isPreUw}
      title={() => {
        const hasKeywordTooltip = dispMetaInfoList => {
          return dispMetaInfoList.find(info => $utils.isKeywordTooltip(info));
        };

        if (
          $utils.isEmptyArray(group.dispMetaInfoList) ||
          !hasKeywordTooltip(group.dispMetaInfoList)
        ) {
          const title = `${group.policyBfNtceQustNo}.   ${group.itmDispContn}`;
          return (
            <p>
              {title.split('\\n').map((text, index, arr) => (
                <span key={index}>
                  {text}
                  {index < arr.length - 1 && <br />}
                </span>
              ))}
            </p>
          );
        }

        return (
          <div className="box-item-tootip">
            {`${group.policyBfNtceQustNo}.   `}
            {group.dispMetaInfoList
              .filter(info => $utils.isKeywordTooltip(info))
              .map(info => ({
                ...info,
                index:
                  group.itmDispContn.indexOf(info.displayKeyword) +
                  info.displayKeyword.length,
              }))
              .sort((a, b) => a.index - b.index)
              .reduce((acc, cur, idx, arr) => {
                let prevIndex = 0;
                let next = {};
                if (idx > 0) {
                  acc.pop();
                  prevIndex = arr[idx - 1].index;
                  if (idx < arr.length - 1) {
                    next = arr[idx + 1];
                  }
                }

                acc.push({
                  ...cur,
                  itmDispContn: group.itmDispContn.substring(
                    prevIndex,
                    cur.index,
                  ),
                });
                acc.push({
                  ...next,
                  itmDispContn: group.itmDispContn.substring(cur.index),
                });

                return acc;
              }, [])
              .map(info => {
                return (
                  <React.Fragment
                    key={`${info.policyBfNtceItmNo}_${info.bfNtceItmNo}`}
                  >
                    {`${info.itmDispContn} `}
                    {!$utils.isEmptyString(info.dispContn) && (
                      <SatToolTip
                        show={
                          noticeDutyTooltips[
                            `${info.policyBfNtceItmNo}_${info.bfNtceItmNo}`
                          ]
                        }
                        setShow={flag => {
                          setNoticeDutyTooltips({
                            ...noticeDutyTooltips,
                            [`${info.policyBfNtceItmNo}_${info.bfNtceItmNo}`]:
                              flag,
                          });
                        }}
                        toolTips={[
                          {
                            message: () => <p>{info.dispContn}</p>,
                          },
                        ]}
                      />
                    )}
                  </React.Fragment>
                );
              })}
          </div>
        );
      }}
      options={[
        { label: '예', value: 'Y' },
        { label: '아니오', value: 'N' },
      ]}
      useType={group.policyBfNtceInsTyCd === '02' ? '' : 'btn'}
      name={group.policyBfNtceItmGrpNo}
      selectValue={
        tbNbsPolicyBfNtceAnsDtlDTO.find(
          dtl => dtl.policyBfNtceItmGrpNo === group.policyBfNtceItmGrpNo,
        )?.ansYn
      }
      onClick={value => {
        let newTbNbsPolicyBfNtceAnsDtlDTO;
        if (
          tbNbsPolicyBfNtceAnsDtlDTO.find(
            item => item.policyBfNtceItmGrpNo === group.policyBfNtceItmGrpNo,
          )
        ) {
          newTbNbsPolicyBfNtceAnsDtlDTO = tbNbsPolicyBfNtceAnsDtlDTO.map(
            item => {
              if (item.policyBfNtceItmGrpNo === group.policyBfNtceItmGrpNo) {
                return {
                  ...item,
                  ansYn: value,
                };
              }
              return item;
            },
          );
        } else {
          newTbNbsPolicyBfNtceAnsDtlDTO = [
            ...tbNbsPolicyBfNtceAnsDtlDTO,
            $utils.createTbNbsPolicyBfNtceAnsDtlDTO({
              ansYn: value,
              policyBfNtceId: group.policyBfNtceId,
              policyBfNtceItmGrpNo: group.policyBfNtceItmGrpNo,
            }),
          ];
        }

        setTbNbsPolicyBfNtceAnsDtlDTO(newTbNbsPolicyBfNtceAnsDtlDTO);
        onSave(
          value,
          { group },
          {
            tbNbsPolicyBfNtceAnsDtlDTO: newTbNbsPolicyBfNtceAnsDtlDTO,
            tbNbsPolicyBfNtceAnsByitmDtlDTO,
          },
        );
      }}
    />
  );
};

export default QuestionArea;
